export default [
  {
    path: '/service/index',
    name: 'Index',
    component: () => import('@/views/service/index'),
    meta: {
      title: '问题反馈中心-高考直通车'
    }
  },
  {
    path: '/service/contact',
    name: 'Contact',
    component: () => import('@/views/service/contact'),
    meta: {
      title: '问题反馈中心-高考直通车'
    }
  }
]
